import { TextInput } from '@innovixx/react-form-fields';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useColor } from '../../../../providers/ColorProvider';
import colors from '../../../../styles/colors/index.module.scss';

export const UpdateColor: React.FC = () => {
  const { control } = useForm();
  const { primaryColor, secondaryColor, setPrimaryColor, setSecondaryColor } = useColor();

  return (
    <form>
      <TextInput
        control={control}
        name="primaryColor"
        label="Primary Color"
        value={primaryColor || colors.primary}
        onChange={(val) => setPrimaryColor(`${val}`)}
      />
      <TextInput
        control={control}
        name="secondaryColor"
        label="Secondary Color"
        value={secondaryColor || colors.secondary}
        onChange={(val) => setSecondaryColor(`${val}`)}
      />
    </form>
  );
};
